import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";

import iconRight from "../right-arrow.svg";

import styles from "./Transports.module.scss";

function TransportBody({
    id,
    iconUrl,
    number,
    type,
    moveMapToTransport,
    showPopup,
    showTrack,
    hideTrackButtons,
}) {
    const focusOnTransport = useCallback(() => {
        moveMapToTransport(id);

        setTimeout(() => {
            showPopup(id);
        }, 300);
    }, [id, moveMapToTransport, showPopup]);

    const showTrackHandler = useCallback(() => {
        showTrack(id);
    }, [id, showTrack]);

    return (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        <div onClick={focusOnTransport} className={styles.transport}>
            <img src={iconUrl} className={styles.icon} />
            <div className={styles.baseInfo}>
                <div className={styles.number} title={number}>
                    {number}
                </div>
                <div className={styles.type} title={type}>
                    {type}
                </div>
            </div>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            {hideTrackButtons ? null : (
                <div
                    onClick={showTrackHandler}
                    className={styles.showTrackButton}
                >
                    Трек
                    <img src={iconRight} alt="Показать еще" />
                </div>
            )}
        </div>
    );
}

TransportBody.propTypes = {
    id: PropTypes.number.isRequired,
    iconUrl: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    moveMapToTransport: PropTypes.func.isRequired,
    showPopup: PropTypes.func.isRequired,
    showTrack: PropTypes.func.isRequired,
    hideTrackButtons: PropTypes.bool,
};

const Transport = memo(TransportBody);

Transport.propTypes = {
    id: PropTypes.number.isRequired,
    iconUrl: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    moveMapToTransport: PropTypes.func.isRequired,
    showPopup: PropTypes.func.isRequired,
    showTrack: PropTypes.func.isRequired,
    hideTrackButtons: PropTypes.bool,
};

export { Transport };
